<template>
    <v-dialog v-model="obModal.open" :max-width="tamModal" :scrollable="$root.isTouch == false"
        :fullscreen="$root.isTouch" persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card"> 
                <span class="white--text headline" v-html="obModal.titulo"></span>
            </v-card-title>
            <v-card-text>
                <v-container fluid grid-list-sm>

                    <v-row dense>
                        <v-col cols="12" sm="6"/>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Buscar" color="textbox" v-model="obModal.search" clearable
                            prepend-inner-icon="search" dense/>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="12">
                            <v-data-table :search="obModal.search" :headers="listGeneral.cabeceraModal" :items-per-page="5"
                                    :items="listGeneral.detalleModal" class="elevation-3">                                    
                                    <template v-slot:no-results>
                                        Tu búsqueda de "<span v-text="obModal.search"></span>" no arrojó resultados.
                                    </template>
                            </v-data-table>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col class="text-right">
                            <v-btn outlined rounded color="danger" class="mr-1" @click="close(false)"> Cancelar</v-btn>
                        </v-col>
                    </v-row>

                </v-container>
                
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name:'ModalBeneficioAseguradoComponent',
        inject:['close'],
        props:{
            obModal:{
                type:Object,
                default:{}
            },
            listGeneral:{
                type:Object,
                default: {}
            }
        }
    }
</script>